import { render } from "./empty_box.vue?vue&type=template&id=37025874&scoped=true"
import script from "./empty_box.vue?vue&type=script&lang=js"
export * from "./empty_box.vue?vue&type=script&lang=js"

import "./empty_box.vue?vue&type=style&index=0&id=37025874&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\inner-training\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37025874"]])

export default __exports__